import router from './router'
import store from './store'
import {getToken} from '@/utils/auth'
import {isRelogin} from '@/utils/request'
import cache from '@/plugins/cache'
import axios from "axios";


const whiteList = ['/login', '/auth-redirect', '/bind',
    '/register', '/index', '/SharingList', '/DataShareDetail', '/ProcessTabs']

router.beforeEach(async (to, from, next) => {
    console.log('--------------to, from, next', to, from, next)
    console.log('--location--', window.location)
    console.log('--pathname--', window.location.pathname)
    // 设置页面标题
    document.title = to.meta.title || '业财易联云平台'
    // 是否由企业微信访问
    let isWeChatEnterprise = false;

    /**
     * WeChatEnterprise 参数来自企业微信应用入口链接配置
     * useCodeGetToken 为前端向企微请求code时携带重定向参数，用于识别是企微重定向回来的请求
     * */
    if (to.query.WeChatEnterprise || (to.query.state && to.query.state.includes('useCodeGetToken'))) {
        isWeChatEnterprise = true;
    }

    // 1:自建，2:三方
    let environmentType = 2
    // 将environmentType存储到vuex中
    store.commit('SET_ENVIRONMENT_TYPE', environmentType)

    if (environmentType == 1) {
        // state=useCodeGetToken，代表由企业微信拿到code重定向到本页面。企业微信获取授权后到后台请求token
        if (to.query.state && to.query.state.includes('useCodeGetToken') && !getToken() && whiteList.indexOf(to.path) == -1) {
            let stateParams = to.query.state.split('|');
            let agentid = stateParams[1];
            let code = to.query.code;
            await getTokenForWeb({code, agentid}).catch((e) => {
                // 当前企微用户在系统中未关联，跳转到登录页
                console.error(e);
                // next(`/login?redirect=${to.fullPath}`)
            });
        }

        if (getToken()) { // 有token
            /* has token*/
            console.log('to.path---------', to.path, 'store.getters.roles---------', store.getters.roles)
            if (to.path === '/login') {
                console.log('per.js--1----自建-----next({path: \'/\'})')
                next({path: '/'})
            } else if (store.getters.roles.length === 0) {
                console.log('per.js--2---------')
                console.log('判断住自建系统---有userInfo')
                isRelogin.show = true
                if (sessionStorage.getItem('userInfo')) {
                    next()
                } else {
                    // 判断当前用户是否已拉取完user_info信息
                    store.dispatch('GetInfo').then(() => {
                        isRelogin.show = false
                        next()
                    }).catch(err => {
                        store.dispatch('LogOut').then(() => {
                            // Message.error(err)
                            next({path: '/'})
                        })
                    })
                }
            } else {
                console.log('per.js--2---8------', to)
                next()
            }
        } else {
            console.log('per.js--3------')
            if (whiteList.indexOf(to.path) !== -1) {
                console.log('per.js--3----1--')
                // 在免登录白名单，直接进入
                next()
            }
            // 企业微信跳转过来没有权限，此处向企业微信获取用户code，如果已经有code代表企微用户无权限
            else if (isWeChatEnterprise && !to.query.code) {
                console.log('per.js--3----2--')
                let redirectUrl = window.location.protocol + '//' + window.location.host + to.fullPath;
                let appid = to.query.appid;
                let agentid = to.query.agentid;
                redirectWxAuth(redirectUrl, appid, agentid);
            } else {
                console.log('per.js--3----3--')
                next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
            }
        }
    } else {
        // state=useCodeGetToken，代表由企业微信拿到code重定向到本页面。企业微信获取授权后到后台请求token
        if (to.query.useid) {
            let userid = to.query.useid;
            console.log(66666);
            await getTokenForWeb({userid: userid}).catch((e) => {
                // 当前企微用户在系统中未关联，跳转到登录页
                console.error(e, 5555);
                // next(`/login?redirect=${to.fullPath}`)
            });
        }

        console.log('per.js---getToken()------------', getToken())
        let userInfoStr = cache.session.get('userInfo');
        let userInfo = JSON.parse(cache.session.get("userInfo"))
        console.log('userInfo', userInfo)
        if (getToken()) { // 有token
            /* has token*/
            console.log('to.path---------', to.path, 'store.getters.roles---------', store.getters.roles)
            if (to.path === '/login') {
                console.log('per.js--1-----三方----next({path: \'/homePage\'})')
                next({path: '/homePage'})
            } else if (store.getters.roles.length === 0) {
                console.log('per.js--2---------')
                console.log('per.js--2--1----userInfo', userInfo)
                console.log('判断住三方')
                if (userInfoStr) {
                    console.log('per.js--2---2---------', to, from)
                    next()
                } else {
                    store.dispatch('GetInfo').then(res => {
                        console.log('per.js--2---3--1----GetInfo-------------')
                        console.log('per.js--2---3--1-------', store.state)
                        var wechatAccount = userInfoStr && userInfo.wechatAccount ? userInfo.wechatAccount : store.state.user.userInfo.wechatAccount
                        setLoginByWx(wechatAccount, next)
                    }).catch((error) => {
                        console.log('per.js--2---6--GetInfo----', error)
                        store.dispatch('LogOut').then(() => {
                            console.log('per.js--2---7---GetInfo---', err)
                            next({path: '/login'})
                        })
                    })
                }
            } else {
                console.log('per.js--2---8------', to)
                next()
            }
        } else {
            console.log('per.js--3------')
            if (whiteList.indexOf(to.path) !== -1) {
                console.log('per.js--3----1--')
                if (userInfoStr) {
                    let wechatAccount = userInfo.wechatAccount
                    console.log('per.js--3----2---wechatAccount--', userInfo.wechatAccount)
                    setLoginByWx(wechatAccount, next)
                } else {
                    console.log('per.js--3----3--')
                    var code = getQuery('code')
                    var userid = getQuery('useid')
                    var corpid = getQuery('corpid')
                    if (code) {
                        getWechatAuth(next)
                    } else {
                        if (userid && corpid) {
                            localStorage.setItem('corpid', corpid)
                            setLoginByWx(userid, next)
                        } else {
                            next() // 否则全部重定向到登录页
                            return
                        }
                    }
                }
            }
            // 企业微信跳转过来没有权限，此处向企业微信获取用户code，如果已经有code代表企微用户无权限
            else if (isWeChatEnterprise && !to.query.code) {
                console.log('per.js--3----2--')
                let redirectUrl = window.location.protocol + '//' + window.location.host + to.fullPath;
                let appid = to.query.appid;
                let agentid = to.query.agentid;
                redirectWxAuth(redirectUrl, appid, agentid);
            } else {
                console.log('per.js--3----3--')
                next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
            }
        }
    }
})


// 从微信请求code
const redirectWxAuth = (redirectUrl, appid, agentid) => {
    let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
        + 'appid=' + appid
        + '&redirect_uri=' + redirectUrl
        + '&response_type=code&scope=snsapi_base&state=useCodeGetToken|' + agentid
        + '&agentid=' + agentid
        + '#wechat_redirect';
    window.location.href = url;
}

// 根据微信code从后台拿到token写入cookie
const getTokenForWeb = (info) => {
    return new Promise((resolve, reject) => {
        store.dispatch("LoginByWx", info).then(() => {
            console.log("企业微信获取了授权，已经将token放入了cookie");
            resolve();
        }).catch((e) => {
            console.error(e, 56859);
            reject();
        });
    })
}

/**
 * @description: 获取 用户信息 并 执行获取token
 * @author: 张佳敏
 * @return {*}
 */
const getWechatAuth = (next) => {
    let code = getQuery('code')
    console.log('code----', code)
    // let uri = `https://ruixin.nmgheli.com/wechat/auth2?code=${code}`;// 测试
    // let uri = `https://dev.nmgheli.com/wechat/auth2?code=${code}`;// 正式

    const baseURL = process.env.VUE_APP_BASE_URL || 'https://dev.nmgheli.com';
    let uri = `${baseURL}/wechat/auth2?code=${code}`;// 正式

    console.log('per.js---getWechatAuth-----uri-----', uri);
    axios.get(uri).then(res => {
        console.log('per.js---getWechatAuth---------', res)
        var data = res.data.data;
        var wechatAccount = data.userid
        localStorage.setItem('avatar', data.avatar)
        localStorage.setItem('corpid', data.corpid)
        if (wechatAccount) {
            // console.log('per.js---getWechatAuth--------wechatAccount---', wechatAccount)
            setLoginByWx(wechatAccount, next)
        }
    }).catch(error => {
        console.log('per.js---getWechatAuth-----------gggggggg', error);
    })
}

/**
 * @description: 获取token
 * @author: 张佳敏
 * @return {*}
 */
const setLoginByWx = (wechatAccount, next) => {
    console.log('per.js---setLoginByWx---------')
    console.log('per.js---setLoginByWx---', wechatAccount, next, store)
    // console.log('per.js---setLoginByWx---store----', store)
    if (wechatAccount) {
        store.dispatch('LoginByWx', {userid: wechatAccount}).then(() => {
            store.dispatch('GetInfo').then((res) => {
                // console.log('per.js---setLoginByWx----GetInfo ---',res)
                // window.location.href.includes('/myWork')
                if (window.location.pathname === '/myWork') {
                    next({path: `${window.location.pathname}?flagClose=1`})
                } else if (window.location.pathname === '/paySheet') {
                    const id = getQuery('id')
                    next({path: `${window.location.pathname}?id=${id}&flagClose=1`})
                } else if (window.location.pathname === '/reportPush') {
                    const url = getQuery('url')
                    const fileSize = getQuery('fileSize')
                    const fileName = getQuery('fileName')
                    next({path: `${window.location.pathname}?url=${url}&fileSize=${fileSize}&fileName=${fileName}&remark=third`})
                } else {
                    next({path: '/homePage'})
                }
            })
        })
    }
}

/**
 * @description: 获取 用户信息 并 执行获取token
 * @author: 张佳敏
 * @return {*}
 */
const getQuery = (queryName) => {
    let queryValue = '';
    let query = window.location.search.substring(1);
    let params = query.replace(/%3D/g, "=").replace(/%3F/g, "&");
    params = params.split("&");
    params.map(i => {
        let pair = i.split("=")
        if (pair[0] == queryName) {
            queryValue = pair[1]
        }
    })
    return queryValue
}
